export const couponsApiPath = {
  getCoupons: '/v2/curators/coupons',
  getCouponsCount: '/v2/curators/coupons/count',
  postCouponReceive: (couponNo: number) => `/v2/curators/coupons/${couponNo}/receive`,
  postCouponReceiveAll: '/v2/curators/coupons/receive-all',
  getCouponGoods: (couponNo: number) => `/v2/curators/coupons/${couponNo}/goods`,
  getCouponGoodsCount: (couponNo: number) => `/v2/curators/coupons/${couponNo}/goods/count`,
  getCouponGoodsCategories: (couponNo: number) =>
    `/v2/curators/coupons/${couponNo}/goods/categories`,
} as const;
